import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import type { MVPProfile, Profile } from '@entities/agent-contract';

import type { MVPProfileCodeData, MVPProfileWorkData } from '../model';

export const useGetMVPData = (profile?: Profile, mvpProfile?: MVPProfile) => {
  const { t } = useTranslation();
  const { employmentDetails } = profile || {};
  const { departmentName, managerName } = employmentDetails || {};
  const {
    lnrCode7778,
    lnrCode719,
    departmentCode,
    departmentAddress,
    managerEmail,
  } = mvpProfile || {};

  const isCodeDataExists = !!lnrCode719 || !!lnrCode7778;
  const isWorkDataExists =
    !!departmentName ||
    !!departmentAddress ||
    !!departmentCode ||
    !!managerEmail;

  return useMemo<{
    codeData: MVPProfileCodeData;
    workData: MVPProfileWorkData;
    isCodeDataExists: boolean;
    isWorkDataExists: boolean;
  }>(
    () => ({
      isCodeDataExists,
      isWorkDataExists,
      codeData: {
        lnrCode7778,
        lnrCode719,
      },
      workData: {
        department: departmentName,
        departmentAddress,
        departmentCode,
        managerName: managerName || t('AGENT_PROFILE:values.managerName'),
      },
    }),
    [
      isCodeDataExists,
      isWorkDataExists,
      lnrCode7778,
      lnrCode719,
      departmentName,
      departmentAddress,
      departmentCode,
      managerName,
    ]
  );
};
